module.exports = __webpack_public_path__ + "static/img/app.115b52b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/develop/soft/app.jpg
// module id = GJc4
// module chunks = 0